module.exports = {
  maxGuests: 6
}